var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box-content-overview",style:(_vm.styleObj)},[_c('BoxHeadline',{attrs:{"color":_vm.box.textColor,"overview":"","text":_vm.$t(("frontpage-ufe:box." + (_vm.box.locizeIdentifier) + ".headline"))}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }